import React, { useState } from 'react';
import { ChevronRight, ChevronDown, Shield, Layers, Zap } from 'lucide-react';
import './ChatComponents.css';

/**
 * Expandable tree of capabilities organized by pillar
 */
function CapabilityTree({ title, data, actions, onAction }) {
  const [expanded, setExpanded] = useState({});

  const togglePillar = (pillarName) => {
    setExpanded(prev => ({
      ...prev,
      [pillarName]: !prev[pillarName],
    }));
  };

  const handleCapabilityClick = (cap) => {
    if (actions?.find(a => a.type === 'item_click') && onAction) {
      const action = actions.find(a => a.type === 'item_click');
      const query = action.queryTemplate.replace('{name}', cap.name);
      onAction({ type: 'query', query });
    }
  };

  const getPillarIcon = (name) => {
    const lower = name?.toLowerCase() || '';
    if (lower.includes('network')) return <Shield size={14} />;
    if (lower.includes('cloud')) return <Layers size={14} />;
    return <Zap size={14} />;
  };

  return (
    <div className="cc-capability-tree">
      {title && <div className="cc-section-title">{title}</div>}

      <div className="cc-tree-list">
        {data.pillars?.map((pillar, pIdx) => (
          <div key={pIdx} className="cc-tree-pillar">
            {/* Pillar header */}
            <div
              className="cc-pillar-header"
              onClick={() => togglePillar(pillar.name)}
            >
              {expanded[pillar.name] ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
              {getPillarIcon(pillar.name)}
              <span className="cc-pillar-name">{pillar.name}</span>
              <span className="cc-pillar-count">{pillar.capabilities?.length || 0}</span>
            </div>

            {/* Capabilities */}
            {expanded[pillar.name] && (
              <div className="cc-pillar-capabilities">
                {pillar.capabilities?.map((cap, cIdx) => (
                  <div
                    key={cIdx}
                    className="cc-capability-item"
                    onClick={() => handleCapabilityClick(cap)}
                  >
                    <span className="cc-cap-code">{cap.code}</span>
                    <span className="cc-cap-name">{cap.name}</span>
                    {cap.domain && (
                      <span className="cc-cap-domain">{cap.domain}</span>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default CapabilityTree;
